import React from "react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { EnrichedSwarovskiProductFrontend } from "@swo/storefront";
import { Spacer } from "../../../components/_shared-components/arrangement/Space";
import { DescriptionRichText } from "./DescriptionRichText";

export const ProductDetailPageDescription: ReactTFC<{
  productShortDescription: EnrichedSwarovskiProductFrontend["shortDescription"];
}> = props => {
  return (
    <div className={"js-pdp-description"}>
      {props.productShortDescription ? (
        <>
          <DescriptionRichText>
            <p>{props.productShortDescription}</p>
          </DescriptionRichText>
          <Spacer size={"md"} />
        </>
      ) : null}
    </div>
  );
};
